<template>
  <div class="app-container post-template-add">
    <basic-container v-loading="loading">
      <div class="operation">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submit">保存</el-button>
      </div>
      <el-row class="one-line">
        <el-col :span="2">名称</el-col>
        <el-col :span="16">
          <el-input :maxlength="20" v-model="name"></el-input>
        </el-col>
      </el-row>
      <el-row class="one-line">
        <el-col :span="2">内容</el-col>
        <el-col :span="16">
          <RichTextEditor v-model="content"
            placeholder="输入模板内容"
            :maxChars="500" />
        </el-col>
      </el-row>
      <el-row class="one-line">
        <el-col :span="2">分类</el-col>
        <el-col :span="16">
          <el-select v-model="tag" value-key="tagId" @change="tagChange">
            <el-option
              v-for="item in tagOptions"
              :key="item.tagId"
              :label="item.tagName"
              :value="item"
              >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row class="one-line">
        <el-col :span="2">主题</el-col>
        <el-col :span="16">
          <el-select v-model="themeTag"
            value-key="themeTagId"
            clearable
            :disabled="themeTagOptions.length <= 0">
            <el-option
              v-for="item in themeTagOptions"
              :key="item.themeTagId"
              :label="item.themeTagName"
              :value="item"
              >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </basic-container>
  </div>
</template>
<script>
import { addObj } from '@/api/setting/template/postTemplate'
import { getTagsByType, getRelatedTags } from '@/api/basic/tagtype'
import RichTextEditor from '@/components/rich-text-editor/index.vue';
import { themeTagTypeId } from '@/config/const';

export default {
  data () {
    return {
      loading: false,
      name: '',
      content: '',
      tag: null,
      tagOptions: [],
      themeTagOptions: [],
      themeTag: null,
    }
  },
  components: {
    RichTextEditor,
  },
  mounted () {
    this.getTagOptions()
  },
  methods: {
    getTagOptions () {
      getTagsByType({
        type: 2
      }).then(response => {
        this.tagOptions = this.formatTagData(response.data.data)
      }).catch(error => {
        console.error(error)
        this.$message({
          message: '获取帖子分类失败',
          type: 'error'
        })
      })
    },
    // 获取与帖子类别相关的主题
    getRelatedTags(tagId) {
      const query = {
        id: tagId,
        typeId: themeTagTypeId,
      };
      getRelatedTags(query).then((response) => {
        const code = response.status;
        const data = response.data;
        if (code === 200) {
          this.themeTagOptions = [];
          if (data.data) {
            data.data.forEach((record) => {
              this.themeTagOptions.push({
                themeTagId: record.id,
                themeTagName: record.name,
              });
            });
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    tagChange(tag) {
      this.themeTag = null;
      if(tag != null && tag.tagId != null){
        this.getRelatedTags(tag.tagId);
      }
    },
    formatTagData (tags) {
      if (Array.isArray(tags)) {
        return tags.map(x => {
          return {
            tagId: x.id,
            tagName: x.name
          }
        })
      } else {
        return []
      }
    },
    cancel () {
      this.$router.$avueRouter.closeTag()
      this.$router.go(-1)
    },
    validate () {
      if (!this.name) {
        this.$message({
          message: '名称不能为空',
          type: 'error'
        })
        return false
      }
      if (!this.content) {
        this.$message({
          message: '内容不能为空',
          type: 'error'
        })
        return false
      }
      if (!this.tag) {
        this.$message({
          message: '分类不能为空',
          type: 'error'
        })
        return false
      }
      return true
    },
    getParams () {
      let params = {
        name: this.name,
        content: this.content,
        tagId: this.tag.tagId,
        tagName: this.tag.tagName,
      }
      if (this.themeTag !== null) {
        params.themeTagId = this.themeTag.themeTagId;
        params.themeTagName = this.themeTag.themeTagName;
      }
      return params
    },
    submit () {
      if (!this.validate()) {
        return false
      }
      this.loading = true
      addObj(this.getParams()).then(response => {
        if (response.data.data) {
          this.loading = false
          this.$message({
            message: '创建成功',
            type: 'success'
          })
          this.$router.$avueRouter.closeTag()
          this.$router.push({
            path: `/setting/template/post/detail/${response.data.data}`
          })
        }
      }).catch(error => {
        console.error(error)
        this.$message({
          message: '创建失败',
          type: 'error'
        })
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss">
.post-template-add {
  .operation {
    text-align: right
  }
}
</style>
